import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { Component_TimeRangeInput } from '../time-range-input/index.js';
import { IconWithTooltip } from '@app/styles';
import './Editor_TimeRange.scss';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Editor_TimeRange extends TS_EditableItemComponent {
    resolveMiddleIndication = () => {
        if (this.state.editable.hasErrors())
            return _jsx(LL_H_C, { style: { minWidth: '20px', justifyContent: 'center' }, children: _jsx(IconWithTooltip, { content: this.state.editable.hasError(), iconKey: 'attention' }) });
        return _jsx(LL_H_C, { style: {
                fontFamily: 'monospace',
                minWidth: '20px',
                justifyContent: 'center'
            }, children: "-" });
    };
    render() {
        return _jsxs(LL_H_C, { className: 'time-range-editor', children: [_jsx(Component_TimeRangeInput, { placeholder: '0', editable: this.state.editable, index: 0 }), this.resolveMiddleIndication(), _jsx(Component_TimeRangeInput, { placeholder: '∞', className: 'infinity', editable: this.state.editable, index: 1 })] });
    }
}
//# sourceMappingURL=Editor_TimeRange.js.map